
import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    Stack, HStack, Wrap, WrapItem, Center, Select, VStack, useToast
} from '@chakra-ui/react';
import { Form, Field } from 'react-final-form';
import validator from "validator";
import { GENDER, PATIENT_INFORMATION_MAX_AGE } from '../../../constants';
import { apiLoadListPatient } from '../../../redux/apis/PatientApis';
import { getPatientList } from '../../../redux/selectors';
import NoEventPage from '../../../components/NoEvent';

function NewPatient ({ selectedClinic, scheduleDate, selectedMedicalTime, reasonNeedDoctor, patientList, apiLoadListPatient, t }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["selectedClinic", "makeDoctorAppointmentDatas"]);
    const [ isSubmit, setIsSubmit ] = useState(false);
    const [ isValidPhone, setIsValidPhone ] = useState(true);
    const [ formData, setFormData ] = useState({});
    const navigate = useNavigate();
    const toast = useToast();

    useEffect(() => {
        if(isSubmit) {
            if(patientList?.length > 0) {
                toast({
                    description: `Số Căn cước công dân hoặc Số điện thoại đã tồn tại! Bạn vui lòng chuyển qua mục 'ĐÃ TỪNG KHÁM'!`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            } else {
                setCookie("makeDoctorAppointmentDatas", 
                    { 
                        data: {
                            isNewRegister: true,
                            company_id: cookies.selectedClinic?.data?.id,
                            scheduleDate, 
                            selectedMedicalTime, 
                            reasonNeedDoctor,
                            patientDetail: formData
                        }
                    }, 
                    { path: '/', maxAge: PATIENT_INFORMATION_MAX_AGE }
                );

                navigate("/department");
            }
            setIsSubmit(false);
        }
    }, [patientList]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.phone) {
            errors.phone = "Required";
        }
        if(!values.yearOfBirth) {
            errors.yearOfBirth = "Required";
        }
        if(!values.passport) {
            errors.passport = "Required";
        }

        if(values.phone?.length > 0) {
            const isValidPhone = validator.isMobilePhone(values.phone, "vi-VN");
            setIsValidPhone(isValidPhone);
            if(!isValidPhone) {
                errors.validPhone = "Required";
            }
        }

        return errors;
    }

    const onSubmit = async(values) => {
        if(!selectedClinic) {
            toast({
                description: "Bạn chưa chọn Phòng khám!",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        } else if(!scheduleDate) {
            toast({
                description: "Bạn chưa chọn Ngày khám!",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        } else if(!selectedMedicalTime) {
            toast({
                description: "Bạn chưa chọn Giờ khám!",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        } else if(!reasonNeedDoctor || reasonNeedDoctor?.length === 0) {
            toast({
                description: "Bạn chưa nhập lý do cần khám!",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        } else {
            setIsSubmit(true);
            setFormData(values);
            apiLoadListPatient({ 
                company_id: cookies.selectedClinic?.data?.id,
                passport: values.passport,
                phone: values.phone
            });
        }
    }

    if(!(cookies.selectedClinic?.data?.id)) {
        return (
            <React.Fragment>
                <NoEventPage text="Bạn vui lòng chọn phòng khám trước khi tiếp tục!"/>
            </React.Fragment>
        )
    }

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={
                cookies.makeDoctorAppointmentDatas?.data?.isNewRegister ? { ...cookies["makeDoctorAppointmentDatas"]?.data?.patientDetail } : {}
            }
            validate={validate}
            keepDirtyOnReinitialize
            render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Flex direction={{ base: "column", md: "row", lg: "row" }} height="80%" m={2} justify="center" gap={8}>
                            <VStack justify="flex-start" w="100%">
                                <Field name="name">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Full_Name")}</FormLabel>
                                                <Input {...input} type='text' placeholder='' />
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="phone">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Phone")}</FormLabel>
                                                <Input {...input} type='text' placeholder='' />
                                            </Flex>
                                            {
                                                !isValidPhone &&
                                                <FormLabel color="red">Nhập đúng Số Điện Thoại</FormLabel>
                                            }
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="gender">
                                    {({ input, meta }) => (
                                        <FormControl>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Gender")}</FormLabel>
                                                <Select {...input} placeholder={t("Select_Gender")}>
                                                    {
                                                        Object.keys(GENDER).map(key => (
                                                            <React.Fragment key={key}>
                                                                <option value={key}>{GENDER[key]}</option>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </Select>
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="social_insurance">
                                    {({ input, meta }) => (
                                        <FormControl>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel  w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Medical_Card")}</FormLabel>
                                                <Input {...input} type='text' placeholder=''/>
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>
                            </VStack>

                            <VStack justify="flex-start" w="100%">
                                <Field name="yearOfBirth">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Year_Of_Birth")}</FormLabel>
                                                <Input {...input} type='number' placeholder=''/>
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="passport">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Passport")}</FormLabel>
                                                <Input {...input} type='text' placeholder='' />
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="email">
                                    {({ input, meta }) => (
                                        <FormControl>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Email")}</FormLabel>
                                                <Input {...input} type='text' placeholder='' />
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="address">
                                    {({ input, meta }) => (
                                        <FormControl>
                                            <Flex direction={{ base: "column", md: "row", lg: "row"}}>
                                                <FormLabel w={{base: "100%", md: "25%", lg: "25%"}} fontWeight="700">{t("Address")}</FormLabel>
                                                <Input {...input} type='text' placeholder='' />
                                            </Flex>
                                        </FormControl>
                                    )}
                                </Field>
                            </VStack>
                        </Flex>

                        <Center mt={8}>
                            <Button colorScheme='green' type='submit' width="300px" height="70px" isDisabled={!valid}>
                                <Text fontSize="18px" fontWeight="700">{t("Confirm")}</Text>
                            </Button>
                        </Center>
                    </form>
                )
            }}
        />
    )
}

const mapStateToProps = (state) => {
    const patientList =             getPatientList(state);

    return { patientList };
}

export default connect(mapStateToProps, { apiLoadListPatient })(NewPatient);